import { useState } from "react";
import styles from "./Style.module.css";
import { Add } from "./actions/index";
import { useDispatch, useSelector } from "react-redux";

const Ui = () => {
  const [rules, setRules] = useState("");
  const lists = useSelector((s) => s.Reducers.list);
  const dispatch = useDispatch();
  const checker = (arr, val) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].data === val) {
        return true;
      } else {
        return false;
      }
    }
  };
  return (
    <div className={styles.main}>
      <div className="main-div">
        <h2> Hold Your Lists </h2>
      </div>
      <div className="input">
        <input
          className={styles.input}
          name="rules"
          type="text"
          placeholder="Enter Rules"
          required
          value={rules}
          onChange={(e) => {
            setRules(e.target.value);
          }}
          minLength="3"
          maxLength="50"
        />
        {rules.length > 2 ? (
          <i
            className="fa fa-plus"
            onClick={() => {
              if (!checker(lists, rules)) {
                dispatch(Add(rules));
                setRules("");
              } else {
                window.alert("Already Exists!");
              }
            }}
          ></i>
        ) : (
          ""
        )}
      </div>

      <div className={styles.ShowListsdiv}>
        <h3 className={styles.txt}> Show Lists </h3>

        {lists.length > 0 ? (
          lists.map((logs) => {
            return (
              <div className={styles.points} key={logs.id}>
                <span className={styles.span1}>{logs.data}</span>

                <span className={styles.span2}>{logs.time}</span>
                <br />
              </div>
            );
          })
        ) : (
          <>
            <h3> No Rules Added</h3>
          </>
        )}
      </div>
    </div>
  );
};

export default Ui;
